import { TopLeftControlsUIConfig } from "../components/ui/hud/top-left-controls-ui";
import { GameBaseScenario } from "../scenarios/GameBaseScenario";
import { FontSizeMultiplier, GameDataConfig } from "../cvp-webgames-core/Misc/interfaces";
import $ from 'jquery'
import Tools from "../cvp-webgames-core/Misc/Tools";
import { PreCacheItem, PrecacheItemType, SinglePreCacheItem } from "../cvp-webgames-core/pre-caching/pre-cache-item";
import GameManager from "../cvp-webgames-core/GameManager";

export enum PageType {
	Nothing = 'nothing',
	MainMenu = 'mainmenu',
	Scenarios = 'scenarios',
	Scenario1PivBadge = 'PIV Badge',
	Scenario2NonAffiliatedStudents = 'Non-Affiliated Students',
	Scenario3IncorrectPtAdmitted = 'Breach of Confidentiality',
	Scenario4WcWorkStoppage = 'Gloving',
	Scenario5BufferInMri = 'Buffer in MRI',
    Scenario6SurgeryWard = 'Acute Surgery Unit',
	Scenario7Transfusion = 'Transfusion',
	Scenario8RmeTempHum = 'Reusable Medical Equipment (RME)',
	Scenario9GtubeMedAdm = 'G-Tube Medication Administration',
	Scenario10FallWithInjury = 'Fall with Injury'
}

export enum ScoringType {
	bad= 0,
	good= 5,
}

class GeneralAudioCaching extends PreCacheItem {
    public audioKeys = {
        beep_short_off_01: 'beep_short_off_01',
        beep_short_on_01: 'beep_short_on_01',
        chime_bell_ding_01: 'chime_bell_ding_01',
        click_04_01: 'click_04_01',
        digi_plink_01: 'digi_plink_01',
        music_marimba_chord_01: 'music_marimba_chord_01'
    };
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.beep_short_off_01,
				src: process.env.PUBLIC_URL + '/assets/audio/beep_short_off_01.mp3'
			},
            {
				type: PrecacheItemType.Audio,
				key: this.audioKeys.beep_short_on_01,
				src: process.env.PUBLIC_URL + '/assets/audio/beep_short_on_01.mp3'
			},
            {
				type: PrecacheItemType.Audio,
				key: this.audioKeys.chime_bell_ding_01,
				src: process.env.PUBLIC_URL + '/assets/audio/chime_bell_ding_01.mp3'
			},
            {
				type: PrecacheItemType.Audio,
				key: this.audioKeys.click_04_01,
				src: process.env.PUBLIC_URL + '/assets/audio/click_04_01.mp3'
			},
            {
				type: PrecacheItemType.Audio,
				key: this.audioKeys.digi_plink_01,
				src: process.env.PUBLIC_URL + '/assets/audio/digi_plink_01.mp3'
			},
            {
				type: PrecacheItemType.Audio,
				key: this.audioKeys.music_marimba_chord_01,
				src: process.env.PUBLIC_URL + '/assets/audio/music_marimba_chord_01.mp3'
			}
		];
	}
}

export const generalAudioCaching = new GeneralAudioCaching();

export const setVisibilityState = (isEnabled: boolean) => {
    var saveData = getSaveData();
    saveData.isVisibleFocusEnabled = isEnabled;
    saveGame(saveData);

    const styleTag = isEnabled
          ? $(`
            <style>
              *:focus, .special-container:focus-within {
                outline: 3px solid red !important;
              }
    
              .super-special-container:focus {
                border: 3px solid red !important;
              }
              </style>
    `)
          : $(`
          <style>
              *:focus, .special-container:focus-within {
                border: none !important;
                outline: none !important;
              }
              .super-special-container:focus {
                border: none !important;
              }
          </style>
        `);
    $("html > head").append(styleTag);
};

export const setVolumeState = (isEnabled: boolean) => {
    var saveData = getSaveData();
    saveData.isAudioEnabled = isEnabled;
    saveGame(saveData);
    if((window as any)['core-volume-state']) {
        (window as any)['core-volume-state'](isEnabled);
    }

    const videos = document.getElementsByTagName('video');

    for(var indx = 0; indx < videos.length; indx++) {
        videos[indx].muted = !isEnabled;
    }
    (window as any)['muted-audio'] = !isEnabled;
    ((window as any)['core-gm'] as GameManager).SoundManager.mutedAudio = !isEnabled;
};

export const setClosedCaptionState = (isEnabled: boolean) => {
    var saveData = getSaveData();
    saveData.isClosedCaptionEnabled = isEnabled;
    saveGame(saveData);
    if((window as any).forceUpdateInternalCCComp) {
        (window as any).forceUpdateInternalCCComp();
    }

    if((window as any)['core-cc-state']) {
        (window as any)['core-cc-state'](isEnabled);
    }
};

export const setMotionState = (isEnabled: boolean) => {
    var saveData = getSaveData();
    saveData.isMotionEnabled = isEnabled;
    (window as any)['core-motion-disabled'] = !isEnabled;
    saveGame(saveData);

    if((window as any)['core-motion-state']) {
        (window as any)['core-motion-state'](isEnabled);
    }

    if(localStorage.getItem('isInAccessibilityScreen-jcdst') === '1') {
        return;
    }

    const iframe:any = document.getElementsByTagName('iframe')[0];

    if(iframe) {
        iframe.contentWindow.postMessage(saveData.isMotionEnabled ? 'resume' : 'pause')
    }

    const vidToStop: HTMLVideoElement = document.querySelector('.main-menu-root video');

    if(vidToStop) {
        if(saveData.isMotionEnabled) {
            vidToStop.play();
        } else {
            vidToStop.pause();
        }
    }
};

export const setAnimationState = (isEnabled: boolean) => {
    var saveData = getSaveData();
    saveData.isAnimationsEnabled = isEnabled;
    saveGame(saveData);
};

export const topLeftMenuProps = (scenario: GameBaseScenario, onReturnToMainMenuClicked?: () => void, onForceRefreshEntireUI?: () => void, disableAria?: string, mmColor?: string) => { 
    var result: TopLeftControlsUIConfig = {
        onForceRefreshEntireUI: onForceRefreshEntireUI,
        onAudioToggled: (isEnabled: boolean) => {
            setVolumeState(isEnabled)
        },
        onToggleCC: (isEnabled: boolean) => {
            setClosedCaptionState(isEnabled)
        },
        onTogglePause: (isEnabled: boolean) => {
            setMotionState(isEnabled)
        },
        onReturnToMenuClicked: () => {
            (window as any)['set-508-window-return-to-main-menu-on']();
            if(scenario) {
                scenario.uiWrapper.displayReturnToMainMenu({
                    topId: 'return-to-main-menu-content-top',
                    bottomId: 'return-to-main-menu-content-bottom',
                    onGoToMainMenuClicked: () => {
                        scenario.gameManager.customData.updateWindow(PageType.MainMenu);
                    },
                    onCancelClicked: () => {
                        (window as any)['set-508-window-return-to-main-menu-off']();
                    }
                });
            } else if(onReturnToMainMenuClicked) {
                onReturnToMainMenuClicked();
            }
            
        },
        mmAria: disableAria,
        mmColor: mmColor
    };

    return result
}

let partId = 0;
export const getNextPartId = () => {
    return 'Scenario Part ' + (partId++).toString();
}

export const getWindowVariable = (key: string) => {
    return (window as any)[key];
}

export const setFocus = (id: string, onDone?: (success: boolean) => void) => {
    if(localStorage.getItem('accessibility_menu_open-jcdst')) {
        return;
    }
    if(document.activeElement.id !== id) {
        setTimeout(() => {
            const el = document.getElementById(id);
    
            setFocusToElement(el, onDone);
        }, 250);
    }
}

export const setFocusToElement = (el: HTMLElement, onDone?: (success: boolean) => void) => {
    if(el) {
        el.focus();
        if(onDone) {
            onDone(true);
        }
    } else {
        if(onDone) {
            onDone(false);
        }
    }
}

export const saveGame = (data: GameDataConfig): void => {
    localStorage.setItem('saved-game-jcdst', JSON.stringify(data));
}

let last508WindowId: string = undefined;

export const setLast508WindowId = (id: string): void => {
    last508WindowId = id;
    disableAnyKeyPress();
}

export const updateLast508Window = (): void => {
    if(last508WindowId) {
        setFocus(last508WindowId, () => {
            enableKeyPress();
        });
    } else {
        enableKeyPress();
    }
}

export const enableKeyPress = () => {
    document.onkeydown = (evt) => {
    }
}

export const disableAnyKeyPress = () => {
    document.onkeydown = (evt) => {
        evt.preventDefault();
    }
}

export const setUp508 = (onGetCurrent508WindowLayer: () => {objects: string[]}) => {
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Tab' || e.which === 9) {
            let current508Layer = onGetCurrent508WindowLayer();

            if(current508Layer.objects.length !== 2) {
                return;
            }

            let lastObj = current508Layer.objects[current508Layer.objects.length - 1]
    
            //508 Window Constraint
            if (e.shiftKey) {
                if (document.activeElement.id === current508Layer.objects[0]) {
                    setFocus(lastObj);
                    e.preventDefault();
                }
            } else {
                if (document.activeElement.id === lastObj) {
                    setFocus(current508Layer.objects[0]);
                    e.preventDefault();
                }
            }
        }
    });
}

export enum TextHtmlTagType {
    p,
    h1,
    h2
}

export const getGlobalTextSizeStyle = (type: TextHtmlTagType) => {
    var saveData = getSaveData();
    const possibleSizes = [];
    possibleSizes[FontSizeMultiplier.big] = {
        p: 20,
        h1: 25,
        h2: 23
    };
    possibleSizes[FontSizeMultiplier.med] = {
        p: 17,
        h1: 22,
        h2: 20
    };
    possibleSizes[FontSizeMultiplier.small] = {
        p: 14,
        h1: 19,
        h2: 17
    };

    let size = 0;

    switch(type) {
        case TextHtmlTagType.p:
            size = possibleSizes[saveData.fontSizeMultiplier].p;
            break;
        case TextHtmlTagType.h1:
            size = possibleSizes[saveData.fontSizeMultiplier].h1;
            break;
        case TextHtmlTagType.h2:
            size = possibleSizes[saveData.fontSizeMultiplier].h2;
            break;
    }

    return {
        fontSize: size + 'pt'
    }
}

export const parseDynamicHtml = (src: string) => {
    return src.replace('<p class=', `<p style="font-size: ${getGlobalTextSizeStyle(TextHtmlTagType.p).fontSize}" class=`)
    .replace('<h1 class=', `<h1 style="font-size: ${getGlobalTextSizeStyle(TextHtmlTagType.h1).fontSize}" class=`)
    .replace('<h2 class=', `<h2 style="font-size: ${getGlobalTextSizeStyle(TextHtmlTagType.h2).fontSize}" class=`);
}

const onGetInitialScenarios = () => {
    const inOrderScenarios = [{
        scenarioWindow: PageType.Scenario1PivBadge,
        isLocked: false,
        isCompleted: false,
        score: 0,
        maxScore: 25,
        MaxQuestions: 5,
        gaugeValue: 5,
        gaugeMax: 5,
        area: -1,
        aarEntries: ([] as any)
    }]
    const randomScenarios = [
        {
            scenarioWindow: PageType.Scenario2NonAffiliatedStudents,
            isLocked: true,
            isCompleted: false,
            score: 0,
            maxScore: 25,
            MaxQuestions: 5,
            gaugeValue: 5,
            gaugeMax: 5,
            area: -1,
            aarEntries: ([] as any)
        },
        {
            scenarioWindow: PageType.Scenario3IncorrectPtAdmitted,
            isLocked: true,
            isCompleted: false,
            score: 0,
            maxScore: 25,
            MaxQuestions: 5,
            gaugeValue: 5,
            gaugeMax: 5,
            area: -1,
            aarEntries: []
        },
        {
            scenarioWindow: PageType.Scenario4WcWorkStoppage,
            isLocked: true,
            isCompleted: false,
            score: 0,
            maxScore: 25,
            MaxQuestions: 5,
            gaugeValue: 5,
            gaugeMax: 5,
            area: -1,
            aarEntries: []
        },
        {
            scenarioWindow: PageType.Scenario5BufferInMri,
            isLocked: true,
            isCompleted: false,
            score: 0,
            maxScore: 25,
            MaxQuestions: 5,
            gaugeValue: 5,
            gaugeMax: 5,
            area: -1,
            aarEntries: []
        },
        {
            scenarioWindow: PageType.Scenario6SurgeryWard,
            isLocked: true,
            isCompleted: false,
            score: 0,
            maxScore: 25,
            MaxQuestions: 5,
            gaugeValue: 5,
            gaugeMax: 5,
            area: -1,
            aarEntries: []
        },
        {
            scenarioWindow: PageType.Scenario7Transfusion,
            isLocked: true,
            isCompleted: false,
            score: 0,
            maxScore: 25,
            MaxQuestions: 5,
            gaugeValue: 5,
            gaugeMax: 5,
            area: -1,
            aarEntries: []
        },
        {
            scenarioWindow: PageType.Scenario8RmeTempHum,
            isLocked: true,
            isCompleted: false,
            score: 0,
            maxScore: 25,
            MaxQuestions: 5,
            gaugeValue: 5,
            gaugeMax: 5,
            area: -1,
            aarEntries: []
        },
        {
            scenarioWindow: PageType.Scenario9GtubeMedAdm,
            isLocked: true,
            isCompleted: false,
            score: 0,
            maxScore: 25,
            MaxQuestions: 5,
            gaugeValue: 5,
            gaugeMax: 5,
            area: -1,
            aarEntries: []
        },
        {
            scenarioWindow: PageType.Scenario10FallWithInjury,
            isLocked: true,
            isCompleted: false,
            score: 0,
            maxScore: 25,
            MaxQuestions: 5,
            gaugeValue: 5,
            gaugeMax: 5,
            area: -1,
            aarEntries: []
        }
    ];

    const result = [...inOrderScenarios, ...Tools.shuffle(randomScenarios)];

    return result;
}

export const getSaveData = (): GameDataConfig => {
    let savedDataRaw = localStorage.getItem('saved-game-jcdst');
    let savedData: GameDataConfig = null;
    if(savedDataRaw) {
        savedData = JSON.parse(savedDataRaw);
    } else {
        let newData: GameDataConfig = {
            isVisibleFocusEnabled: true,
            isAnimationsEnabled: true,
            fontSizeMultiplier: FontSizeMultiplier.small,
            isAudioEnabled: true,
            isClosedCaptionEnabled: true,
            isMotionEnabled: true,
            lastVisitedScenarioIndx: -1,
            scenarios: onGetInitialScenarios()
        };
        savedData = newData;
    }

    return savedData;
}